import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from "angular-datatables";
import {UserService} from "../../services/user.service";
import * as FileSaver from 'file-saver';
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    items: any[];
    @ViewChild(DataTableDirective) private dtElement;
    exporting = false;

    constructor(
        private userService: UserService,
        private toastrService: ToastrService,
    ) {
    }

    ngOnInit(): void {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.userService.datatable(dataTablesParameters)
                    .subscribe(response => {
                        this.items = response.data;
                        callback({
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                {data: 'name'},
                {data: 'email'},
                {data: 'birthday'},
                {data: 'points'},
                {data: 'status_nice', name: 'status'},
            ]
        };
    }

    private async reloadTable() {
        let dtIntance = await this.dtElement.dtInstance;
        dtIntance.ajax.reload();
    }

    exportList(): void {
        this.exporting = true;
        this.userService.exportCustomerList().subscribe(blob => {
            this.exporting = false;
            FileSaver.saveAs(blob, 'Clientes.xlsx');
        }, error1 => {
            this.exporting = false;
            this.toastrService.error(error1);
        });
    }
}
